// extracted by mini-css-extract-plugin
export var button = "_gq-2";
export var card = "_gq-0";
export var closeButtonContainer = "_gq-3";
export var iconContainer = "_gq-1";